<template>
  <div style="background-color: white; width: 100%; height: 100%;" class="d-flex flex-column">
  <div style="width: 100%; height: 100%; max-width: 450px" class="pa-3 ma-auto d-flex flex-column justify-center align-center">
    <div class="text-center">
      <v-avatar color="white" size="80" style="border: 1px solid #E3E5EB !important;">
        <v-img 
            src="../../../assets/logo.png"
            max-width="50"
            contain
            class="logo-image"
          ></v-img>
      </v-avatar>
   
    </div>
    
    <login-card class="w-100"></login-card>

    <v-snackbar v-model="invalidEmail" top>
      Dirección de correo electrónico inválida.
      <v-btn text color="purple" @click="invalidEmail = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</div>
</template>

<script>
import Loader from '../../../components/VLoader'
import controller from "@/store/Controller";
import LoginCard from "./components/LoginCard";

export default {
  components: {
    LoginCard,
    pulseLoader: Loader
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  mounted() {
    if (this.getUser) {
      this.afterLog()
    }
  },
  data() {
    return {
      prevRoute: null,
      controller: controller,
      value: true,
      value2: true,
      text: [
        'Iniciar sesión',
        'Crear nueva cuenta'
      ],
      loginForm: {
        email: '',
        password: ''
      },
      registerForm: {
        name: '',
        email: '',
        password1: '',
        password2: '',
        branca: '',
        assignatures: [],
        nickname: '',
        institut: ''
      },
      errors: null,
      showErrors: false,
      local_dialog: null,
      invalidEmail: false,
      checkbox: false,
      google: false,
      login: false,
      addedAssig: false,
      instituts: null,
      loading: false,
      activated: false,
      errorMessage: null
    }
  },
  computed: {
    prevRoutePath() {
      return this.prevRoute ? this.prevRoute.path : '/'
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.name === 'sm' || this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'md'
    },
    checkDoublePass: function () {
      return (this.registerForm.password1 === this.registerForm.password2) && this.registerForm.password2.length > 6
    },
    getInitial() {
      return this.registerForm.name.substring(0, 1)
    },
    getRandomColor() {
      return '#' + Math.floor(Math.random() * 16777215).toString(16)
    },
    assignatures() {
      return null
    },
    canRegister() {
      return this.checkDoublePass &&
        this.checkbox &&
        this.registerForm.name !== '' &&
        (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.registerForm.email))
    },
    somhi() {
      if (!this.registerForm.branca ||
        !this.registerForm.assignatures ||
        !this.registerForm.institut ||
        !this.registerForm.nickname ||
        this.registerForm.assignatures.length === 0) {
        return true
      }
      return false
    },
    isUserInfo() {
      return (this.getUser.branca && this.getUser.assignatures && this.getUser.nickname && this.getUser.institut)
    }
  },

  methods: {

    toLater() {
      this.local_dialog = false
      this.$router.push({path: '/selectivitat'})
    },
    async onSignIn(email, password) {
      this.loading = true
      try {

        const res = await this.axios.post('/login', {
          user_email: email,
          user_password: password
        })

        if (res.data.user) {
          this.$root.currentUser.value = res.data.user
          this.$root.token.value = res.data.token
          // this.$cookies.set("user", res.data.user)
          // this.$cookies.set("token", res.data.token)
          
          // Conservar los parámetros de la URL al redirigir
          const query = { ...this.$route.query, user_id: res.data.user.user_id };
          this.$router.push({
            path: this.prevRoutePath,
            query
          });
          
          this.login = true;
        }
      } catch (err) {
        if (err && err.response && err.response.status === 401) this.errorMessage = err.response.data.message
      } finally {
        this.loading = false
      }
    },
    async addAssignatura() {
      this.loading = true
      try {
        // await this.$store.commit('addAssignatura', {
        //   branca: this.registerForm.branca,
        //   assignatures: this.registerForm.assignatures,
        //   nickname: this.registerForm.nickname,
        //   institut: this.registerForm.institut
        // })
      } finally {
        this.local_dialog = false
        setTimeout(() => {
          this.$router.push({path: '/selectivitat'})
          this.loading = false
          this.registerForm = {
            name: '',
            email: '',
            password1: '',
            password2: '',
            branca: '',
            assignatures: [],
            nickname: '',
            institut: ''
          }
        }, 700)
      }
    },
    async onRegister() {
      this.loading = true
      const user = {
        user_name: this.registerForm.name,
        user_email: this.registerForm.email,
        user_password: this.registerForm.password1
      }

      try {
        const res = await this.axios.post('/register', user);
        await this.onSignIn(this.registerForm.email, this.registerForm.password1);
      } catch (err) {

        if (err.response.status === 401) this.errorMessage = err.response.data.message
      } finally {
        this.loading = false;
      }
    },
    passVisibility() {
      this.value = !this.value
      if (!this.value2) this.value2 = true
    },
    passVisibility2() {
      this.value2 = !this.value2
      if (!this.value) this.value = true
    },
    close(name) {
      const array = this.registerForm.assignatures
      const index = array.indexOf(name)
      if (index >= 0) array.splice(index, 1)
    },
    // async afterLog() {
    //   this.loading = false
    //   this.google = false
    //   this.login = false
    //   if (this.$route.path === '/') await this.$router.push({path: '/perfil'})
    // }
  },
  watch: {
    'registerForm.password1'(val) {
      if (val && this.registerForm.email) {
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.registerForm.email)) && val !== '') {
          this.invalidEmail = true
        } else {
          this.invalidEmail = false
        }
      }
    },
    local_dialog(val) {
      if (!val) this.loading = false
    },
    getUser(user) {
      if (user && (this.google || this.login)) {
        this.loading = false
        this.afterLog()
      }
    }

  }
}
</script>

<style scoped>
.w-100 {
  width: 100%;
}
</style>
